import { useState, useEffect } from "react";

/** Как на тренажёре: первые 4 с — подготовка окружения, затем выполнение запроса */
const ENVIRONMENT_PHASE_MS = 4000;

export type QueryLoadingPhase = "environment" | "query";

export const QUERY_LOADING_STAGE_LABEL: Record<QueryLoadingPhase, string> = {
  environment: "Поднимаем окружение...",
  query: "Выполняем запрос...",
};

/**
 * Двухфазные подписи лоадера при ожидании ответа бэкенда (тренажёр, блок кода, загрузка курсов и т.д.).
 * При каждом новом `isActive === true` снова начинается фаза «окружение».
 */
export function useQueryLoadingStage(isActive: boolean): QueryLoadingPhase {
  const [phase, setPhase] = useState<QueryLoadingPhase>("environment");

  useEffect(() => {
    if (!isActive) return;
    setPhase("environment");
    const t = setTimeout(() => setPhase("query"), ENVIRONMENT_PHASE_MS);
    return () => clearTimeout(t);
  }, [isActive]);

  return phase;
}
